'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ramda = require('ramda');

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _string_utility = require('../../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _number_utility = require('../../../../packages/common-utilities/src/number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WamWalChart = function (_React$Component) {
  _inherits(WamWalChart, _React$Component);

  function WamWalChart(props) {
    _classCallCheck(this, WamWalChart);

    var _this = _possibleConstructorReturn(this, (WamWalChart.__proto__ || Object.getPrototypeOf(WamWalChart)).call(this, props));

    _this.trackChartHover = false;
    return _this;
  }

  /* eslint-disable*/


  _createClass(WamWalChart, [{
    key: 'createWamWalChart',
    value: function createWamWalChart(printWidth) {
      var _this2 = this;

      var breakpoint = this.props.breakpoint;

      var isDesktop = breakpoint > 3;
      var data = this.props.data.map(function (item) {
        item.formattedDate = _date_formatter2.default.getLocalFormattedDateForInjectIntl(item.date, _this2.props.intl);
        return item;
      });
      var startDate = data[0].date;
      var endDate = data[data.length - 1].date;
      var xAxisTicks = _chart_utility2.default.createXAxisTicksForTwelveMonths(endDate, isDesktop);

      var marginRight = isDesktop ? 20 : 10;
      var rangePaddingRight = isDesktop ? 50 : 10;
      var daysLabel = _string_utility2.default.getLocalizedString(this.props.intl, 'days', 'days-in-lower-case');

      var _NumberUtility$getMax = _number_utility2.default.getMaxAndMinAmount(['wam', 'wal'], data, [0]),
          minAmount = _NumberUtility$getMax.minAmount,
          maxAmount = _NumberUtility$getMax.maxAmount;

      var yTicks = _number_utility2.default.getTicks(minAmount, maxAmount, 0, 100, 10);

      var spec = (0, _ramda.mergeDeepLeft)({
        "keys": ["date"],
        "values": ["wal", "wam"],
        "container": {
          "rangePaddingRight": rangePaddingRight,
          "marginBottom": 50,
          "marginLeft": 55,
          "marginRight": marginRight
        },
        "type": "line",
        "style": {
          "fill": ["#70C4FF", "#00A16D"]
        },
        "axis": {
          "x": {
            "show": true,
            "tick": {
              "padding": 5,
              "values": xAxisTicks
            },
            "label": {
              "show": true,
              "text": function text(data) {
                return _date_formatter2.default.getDateInMonthYearFormat(data);
              }
            },
            "domain": isDesktop ? [d3.timeParse("%Y-%m-%d")(startDate), xAxisTicks[xAxisTicks.length - 1]] : [d3.timeParse("%Y-%m-%d")(startDate), d3.timeParse("%Y-%m-%d")(endDate)]
          },
          "y": {
            "domain": [0, yTicks[yTicks.length - 1]],
            "label": {
              "show": true,
              "text": function text(data) {
                return data + ' ' + daysLabel;
              }
            },
            "tick": {
              "padding": 5,
              "values": yTicks,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            },
            "show": true
          }
        },
        "hoverLine": {
          "tooltip": {
            "text": function text(item) {
              if (!_this2.trackChartHover) {
                _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
                  "eventAction": "weighted average maturity and life in days chart",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
                });
                _this2.trackChartHover = true;
              }
              var textContent = ["<div style= 'text-align:left'>"];
              var colorKey = function colorKey(size, backgroundColor) {
                return '<div class=\'display-inline-block\' style=\'width: ' + size + 'px; height: ' + size + 'px; background: ' + backgroundColor + '; margin-right: 15px; display: inline-block; border-radius: 25px;\'></div>';
              };
              var formattedItem = data.find(function (dataPoint) {
                return dataPoint.date === item.date;
              });

              textContent.push('<div class=\'caption\' style=\'font-weight:400\'>' + formattedItem.formattedDate + '</div>');
              textContent.push('<div>' + colorKey("10", "#70C4FF") + '<div class=\'caption\' style=\'font-weight:100; display: inline-block;\'>' + _string_utility2.default.getLocalizedString(_this2.props.intl, 'Weighted average life:', 'pdp-chart-weighted-average-life-label') + ' ' + item.wal + ' ' + daysLabel + '</div></div>');
              textContent.push('<div>' + colorKey("10", "#00A16D") + '<div class=\'caption\' style=\'font-weight:100; display: inline-block;\'>' + _string_utility2.default.getLocalizedString(_this2.props.intl, 'Weighted average maturity:', 'pdp-chart-weighted-average-maturity-label') + ' ' + item.wam + ' ' + daysLabel + '</div></div>');
              textContent.push("</div>");

              return (0, _ramda.join)("", textContent);
            }
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }
      return _chart_utility2.default.generateChart((0, _chart_utility3.generateChartId)("wamWalChart", printWidth && typeof printWidth === "number"), "linechart", data, spec);
    }

    /* eslint-enable*/

  }, {
    key: 'renderWamWalLegend',
    value: function renderWamWalLegend() {
      var data = this.props.data;

      var lastNode = (0, _ramda.last)(data);
      var wam = lastNode.wam,
          wal = lastNode.wal;

      var createLegendSquare = function createLegendSquare(backgroundColor) {
        return _react2.default.createElement('div', { className: 'display-inline-block', style: {
            width: "20px",
            height: "20px",
            background: backgroundColor,
            marginRight: "15px",
            verticalAlign: "bottom",
            borderRadius: "25px"
          } });
      };

      return _react2.default.createElement(
        'div',
        { className: 'margin-bottom-40' },
        _react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          createLegendSquare("#70C4FF"),
          _react2.default.createElement(
            'span',
            { className: 'font-regular' },
            _string_utility2.default.getLocalizedString(this.props.intl, 'Weighted average life:', 'pdp-chart-weighted-average-life-label')
          ),
          ' ' + wal + ' ' + _string_utility2.default.getLocalizedString(this.props.intl, 'days', 'days-in-lower-case')
        ),
        _react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          createLegendSquare("#00A16D"),
          _react2.default.createElement(
            'div',
            { className: 'font-regular display-inline-block' },
            _string_utility2.default.getLocalizedString(this.props.intl, 'Weighted average maturity:', 'pdp-chart-weighted-average-maturity-label')
          ),
          ' ' + wam + ' ' + _string_utility2.default.getLocalizedString(this.props.intl, 'days', 'days-in-lower-case')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!(0, _ramda.length)(this.props.data)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'print-hide' },
            _react2.default.createElement(this.createWamWalChart())
          ),
          _react2.default.createElement(
            'div',
            { className: 'print-display', style: { display: "none" } },
            _react2.default.createElement(this.createWamWalChart(800))
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderWamWalLegend()
        )
      );
    }
  }]);

  return WamWalChart;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(WamWalChart);